<template>
  <span class="d-inline-flex align-items-center" role="status" aria-live="polite">
    <b-spinner v-if="!small" :variant="variant" :label="label"/>
    <b-spinner v-else small :variant="variant" :label="label"/>
    <span v-if="text" class="ml-2" style="color: var(--text-muted);">{{ text }}</span>
  </span>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    variant: { type: String, default: 'dark' },
    small: { type: Boolean, default: false },
    text: { type: String, default: '' },
    label: { type: String, default: 'Загрузка...' }
  }
}
</script>